import { useState, useEffect } from 'react';
import { clamp, roundHalfToNearest, parseOrNull, isPermissiveNumeric } from '../../../utils/number.esm.js';

function useSingleSliderValue({ min, max, defaultValue, value, onChange, }) {
    var _a;
    const isControlled = value !== undefined;
    const initial = clamp(roundHalfToNearest((_a = value !== null && value !== void 0 ? value : defaultValue) !== null && _a !== void 0 ? _a : min), min, max);
    const [sliderValue, setSliderValue] = useState(initial);
    const [inputText, setInputText] = useState(String(initial));
    useEffect(() => {
        if (!isControlled)
            return;
        if (value == null)
            return;
        const clamped = clamp(value, min, max);
        if (clamped !== sliderValue) {
            setSliderValue(clamped);
            setInputText(String(clamped));
        }
    }, [value, isControlled, min, max, sliderValue]);
    const handleInputChange = (e) => {
        const s = e.target.value;
        if (s === "" || s === "-") {
            setInputText(s);
            if (!isControlled)
                setSliderValue(min);
            return;
        }
        if (!isPermissiveNumeric(s))
            return;
        setInputText(s);
        const parsed = parseOrNull(s);
        if (parsed == null)
            return;
        const clamped = clamp(parsed, min, max);
        if (!isControlled) {
            setSliderValue(clamped);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(clamped);
    };
    const handleInputBlur = () => {
        const parsed = parseOrNull(inputText);
        if (parsed == null) {
            setInputText(String(sliderValue));
            return;
        }
        const committed = clamp(roundHalfToNearest(parsed), min, max);
        if (!isControlled) {
            setSliderValue(committed);
        }
        setInputText(String(committed));
        onChange === null || onChange === void 0 ? void 0 : onChange(committed);
    };
    const handleSliderChange = (vals) => {
        const v = clamp(vals[0], min, max);
        if (!isControlled) {
            setSliderValue(v);
            setInputText(String(v));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(v);
        }
    };
    return {
        sliderValue,
        inputText,
        handleInputChange,
        handleInputBlur,
        handleSliderChange,
    };
}

export { useSingleSliderValue };
